<template>
  <form ref="formRef" novalidate @submit.prevent="saveContacto" class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
    <div class="card-body w-100">
      <div class="d-flex justify-content-between align-items-center mb-3 w-100">
        <h2 class="fw-bold fs-5 m-0 mt-1">{{ $t('infoDeContacto') }}</h2>
        <button @click="editarContacto(true)" v-if="(hasEditarPersonaPermission && !isEditingContacto) || isEditingPerfil" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3 d-flex flex-column">
          <label for="email" class="m-0 texto-secundario fs-7"> {{ $t('emailProfesional') }}</label>
          <p v-if="!isEditingContacto || isEditingPerfil" class="m-0">
            <span v-for="(email, index) in localPersona?.Email?.filter(email => email.TipoEmail == 'Profesional')" :key="'email-prof-view' + index">
              {{ email.email }}
            </span>
            <span v-if="!localPersona?.Email || localPersona?.Email?.filter(email => email.TipoEmail == 'Profesional')?.length == 0">
              {{ 'N/A' }}
            </span>
          </p>
          <div v-if="isEditingContacto && !isEditingPerfil">
            <div v-for="(email, index) in localPersona.Email?.filter(email => email.TipoEmail == 'Profesional')" :key="'email' + index" class="m-0 fs-7 d-flex flex-row gap-2">
              <input type="email" v-model="email.email" class="form-control fondo-principal sombra-sm"/>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">{{ $t('emailsPersonales') }}{{ isEditingPerfil && isEditingContacto ? ' *' : '' }}</label>
          <p v-if="!isEditingContacto" class="m-0">{{ getPersonalEmails(persona.Email) || 'N/A' }}</p>
          <div v-if="isEditingContacto">
            <div v-for="(email, index) in localPersona.Email?.filter(email => email.TipoEmail == 'Personal')" :key="'email-personal' + index" class="d-flex flex-row gap-2 mb-2">
              <div class="d-flex flex-column w-100">
                <input type="email" v-model="email.email" :class="['form-control', 'fondo-principal', 'sombra-sm', { 'is-invalid': errors[email.IdEmail] }]" required />
                <div class="invalid-feedback">{{ errors[email.IdEmail] }}</div>
              </div>
              <button v-if="localPersona.Email?.filter(email => email.TipoEmail == 'Personal').length > 1" type="button" class="btn btn-danger sombra" @click="removeEmail(email.IdEmail)">
                {{ $t('eliminar') }}
              </button>
            </div>
            <button v-if="!isEditingPerfil" type="button" class="btn btn-primary mt-2" @click="addEmail('Personal')">{{ $t('agregarEmail') }}</button>
          </div>
        </div>

        <div v-for="tipo in otherTipos" :key="tipo" class="col-md-6 mb-3 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">{{ $t('emailDe') }} {{ $t(tipo) }}</label>
          <p v-if="!isEditingContacto" class="m-0">{{ getEmailsByTipo(persona.Email, tipo) }}</p>
          <div v-if="isEditingContacto">
            <div v-for="(email, index) in localPersona.Email?.filter(email => email.TipoEmail === tipo)" :key="'email-' + tipo + index" class="d-flex flex-row gap-2 mb-2">
              <div class="d-flex flex-column w-100">
                <input type="email" v-model="email.email" :class="['form-control', 'fondo-principal', 'sombra-sm', { 'is-invalid': errors[email.IdEmail] }]" required />
                <div class="invalid-feedback">{{ errors[email.IdEmail] }}</div>
              </div>
              <button type="button" class="btn btn-danger sombra" @click="removeEmail(email.IdEmail)">
                {{ $t('eliminar') }}
              </button>
            </div>
            <button type="button" class="btn btn-primary mt-2" @click="addEmail(tipo)">{{ $t('agregarEmail') }}</button>
          </div>
        </div>

        <div class="col-md-6 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">{{ $t('celular') }}{{ isEditingPerfil && isEditingContacto ? ' *' : '' }}</label>
          <p v-if="!isEditingContacto" class="m-0">{{ celular || 'N/A' }}</p>
          <input v-if="isEditingContacto" type="number" v-model="celular" :class="['form-control', 'fondo-principal', 'sombra-sm', { 'is-invalid': errors.celular }]" required />
          <div class="invalid-feedback">{{ errors.celular }}</div>
        </div>
        <div class="col-md-6 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7"> {{ $t('telefonoFijo') }}</label>
          <p v-if="!isEditingContacto" class="m-0">{{ telefonoFijo || 'N/A' }}</p>
          <input v-if="isEditingContacto" type="number" v-model="telefonoFijo" class="form-control fondo-principal sombra-sm"/>
        </div>
      </div>
      <div v-if="isEditingContacto" class="d-flex justify-content-end gap-2 mt-3">
        <button class="btn success-btn sombra-sm d-flex align-items-center gap-2" type="submit" :disabled="loadingContacto">
          {{ $t('guardarCambios') }}
          <img v-if="loadingContacto" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </button>
        <button class="btn secondary-btn sombra-sm" type="button" @click="editarContacto(false)">{{ $t('cancelar') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { ref, computed, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'InfoContactoSection',
  props: {
    persona: {
      type: Object,
      required: true
    },
    hasEditarPersonaPermission: {
      type: Boolean,
      default: false
    },
    isEditingPerfil: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    let isEditingContacto = ref(false);
    const loadingContacto = ref(false);
    const errors = ref({});
    const formRef = ref(null);
    const localPersona = ref({
      ...props.persona,
      Telefonos: (props.persona.Telefonos || []).map(t => ({ ...t })),
      Email: (props.persona.Email || []).map(e => ({ ...e }))
    });

    const findOrCreateTelefono = (tipo) => {
      if (!localPersona.value.Telefonos) {
        localPersona.value.Telefonos = [];
      }
      let telefono = localPersona.value.Telefonos.find(t => t.Tipo === tipo);
      if (!telefono) {
        telefono = { Numero: '', Tipo: tipo };
        localPersona.value.Telefonos.push(telefono);
      }
      return telefono;
    };

    const editarContacto = (estado) => {
      isEditingContacto.value = estado;
      if(estado){
        if (!localPersona.value.Email.some( e => e.TipoEmail == 'Profesional' ) && props.hasEditarPersonaPermission) {
          localPersona.value.Email.push({ IdEmail: "00000000-0000-0000-0000-000000000000", IdPersona: null, email: '', TipoEmail: 'Profesional' });
        }
        // Ensure at least one personal email exists
        if (!localPersona.value.Email.some(e => e.TipoEmail == 'Personal') && props.isEditingPerfil) {
          localPersona.value.Email.push({ IdEmail: '00000000-0000-0000-0000-000000000000', email: '', TipoEmail: 'Personal' });
        }
      }else {
        // Reset localPersona to original data
        localPersona.value = {
          ...props.persona,
          Telefonos: (props.persona.Telefonos || []).map(t => ({ ...t })),
          Email: (props.persona.Email || []).map(e => ({ ...e }))
        };
        // Remove the added professional email if editing is cancelled
        const addedEmail = localPersona.value.Email.find(e => e.IdEmail === "00000000-0000-0000-0000-000000000000");
        if (addedEmail) {
          localPersona.value.Email = localPersona.value.Email.filter(e => e.IdEmail !== "00000000-0000-0000-0000-000000000000");
        }
        // Remove added personal email if editing is cancelled and it was empty
        const addedPersonalEmails = localPersona.value.Email.filter(e => e.IdEmail.startsWith('00000000-0000-0000-0000-000000000000') && !e.email.trim());
        addedPersonalEmails.forEach(email => {
          localPersona.value.Email = localPersona.value.Email.filter(e => e.IdEmail !== email.IdEmail);
        });
      }
    };

    const celular = computed({
      get() {
        const tel = localPersona.value.Telefonos?.find(t => t.Tipo === 'Celular');
        return tel ? tel.Numero : '';
      },
      set(newValue) {
        const telefono = findOrCreateTelefono('Celular');
        telefono.Numero = String(newValue);
      }
    });

    const telefonoFijo = computed({
      get() {
        const tel = props.persona.Telefonos?.find(t => t.Tipo === 'Telefono Fijo');
        return tel ? tel.Numero : '';
      },
      set(newValue) {
        const telefono = findOrCreateTelefono('Telefono Fijo');
        telefono.Numero = String(newValue);
      }
    });

    const getPersonalEmails = (emailArray) => {
      if (!Array.isArray(emailArray) || emailArray.length === 0) {
        return 'N/A';
      }

      const personalEmails = emailArray
        .filter(email => email.TipoEmail == 'Personal')
        .map(email => email.email);

      return personalEmails.length > 0 ? personalEmails.join(', ') : 'N/A';
    };

    const getEmailsByTipo = (emailArray, tipo) => {
      if (!Array.isArray(emailArray) || emailArray.length === 0) {
        return 'N/A';
      }

      const emails = emailArray
        .filter(email => email.TipoEmail === tipo)
        .map(email => email.email);

      return emails.length > 0 ? emails.join(', ') : 'N/A';
    };

    const otherTipos = computed(() => {
      const tipos = new Set();
      localPersona.value.Email?.forEach(email => {
        if (email.TipoEmail !== 'Personal' && email.TipoEmail !== 'Profesional') {
          tipos.add(email.TipoEmail);
        }
      });
      return Array.from(tipos);
    });

    const addEmail = (tipo = 'Personal') => {
      if (!localPersona.value.Email) {
        localPersona.value.Email = [];
      }
      localPersona.value.Email.push({ IdEmail: "00000000-0000-0000-0000-000000000000", email: "", TipoEmail: tipo });
    };

    const removeEmail = (id) => {
      localPersona.value.Email = localPersona.value.Email.filter(e => e.IdEmail != id);
    };

    const validateContacto = async () => {
      errors.value = {};
      let isValid = true;

      if(props.isEditingPerfil){
        // Validate emails
        localPersona.value.Email.forEach((email) => {
          if (!email.email || email.email.trim() === '') {
            errors.value[email.IdEmail] = t('emailRequerido');
            isValid = false;
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.email)) {
            errors.value[email.IdEmail] = t('emailInvalido');
            isValid = false;
          }
        });
        // Validate at least one personal email
        const personalEmails = localPersona.value.Email.filter(e => e.TipoEmail === 'Personal');
        if (personalEmails.length === 0 || personalEmails.every(e => !e.email || e.email.trim() === '')) {
          // Add error to the first personal email or create a generic error
          const firstPersonal = personalEmails[0] || localPersona.value.Email.find(e => e.TipoEmail === 'Personal');
          if (firstPersonal) {
            errors.value[firstPersonal.IdEmail] = t('emailPersonalRequerido');
          } else {
            errors.value['personal-email'] = t('emailPersonalRequerido');
          }
          isValid = false;
        }
        // Validate celular
        if (!celular.value || celular.value.toString().trim() === '') {
          errors.value.celular = t('celularRequerido');
          isValid = false;
        }
      } else {
        localPersona.value.Email.forEach((email) => {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.email) && email.email.trim() !== '') {
            errors.value[email.IdEmail] = t('emailInvalido');
            isValid = false;
          }
        });
      }

      await nextTick();
      if (isValid) {
        formRef.value?.classList.add('was-validated');
      } else {
        formRef.value?.classList.remove('was-validated');
      }
      return isValid;
    };

    const saveContacto = async () => {
      if (!(await validateContacto())) {
        return;
      }
      loadingContacto.value = true;
      try {
        const telefonosParaEnviar = localPersona.value.Telefonos
          .filter(t => (t.Tipo === 'Celular' || t.Tipo === 'Telefono Fijo') && t.Numero)
          .map(t => ({ Numero: t.Numero, Tipo: t.Tipo }));

        const emailsParaEnviar = localPersona.value.Email.filter(e => e.email && e.email.trim() !== '');

        const data = {
          Emails: emailsParaEnviar,
          Telefonos: telefonosParaEnviar
        };
        console.log(data)
        await api.put(`api/Persona/${props.persona.IdPersona}/info-contacto`, data);
        isEditingContacto.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al guardar info de contacto:', error);
        alert('Hubo un problema al guardar la información de contacto.');
      } finally {
        loadingContacto.value = false;
      }
    };

    watch(() => props.persona, (newPersona) => {
      localPersona.value = {
        ...newPersona,
        Telefonos: (newPersona.Telefonos || []).map(t => ({ ...t })),
        Email: (newPersona.Email || []).map(e => ({ ...e }))
      };
    }, { immediate: true });

    return {
      t,
      isEditingContacto,
      loadingContacto,
      localPersona,
      celular,
      telefonoFijo,
      getPersonalEmails,
      getEmailsByTipo,
      otherTipos,
      addEmail,
      removeEmail,
      saveContacto,
      editarContacto,
      validateContacto,
      errors,
      formRef,
    };
  },
};
</script>

<style>
</style>

